/* eslint-disable */
<template>
  <div>
    <div class="container-fluid w-100 no-padding">
      <div class="row bg-primary-dark">
        <div class="col-md-8 mb-2 mt-2 align-middle">
          <h4>U-ETDS Entegrasyonu Yapılmış Araçlar</h4>
        </div>
        <div class="col-md-4 mb-2 mt-2">
          <button class="btn btn-more-radius btn-success float-right mr-2" data-toggle="modal" data-target="#uetdsModal">Yeni Araç Ekle</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <v-wait for="teklifler-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Veriler yükleniyor...</p>
              </div>
            </template>
            <table class="table table-bordered table-striped table-hover">
              <thead class="thead-light">
                <tr>
                  <th style="width: 32px;" scope="col">#</th>
                  <th style="width: 5%;" scope="col">MÜŞTERİ</th>
                  <th style="width: 10%;" scope="col">ARAÇ BİLGİSİ</th>
                  <th style="width: 10%;" scope="col">SÖZLEŞME</th>
                  <th style="width: 10%;" scope="col">UETDS KULLANICI</th>
                  <th style="width: 10%;" scope="col">UETDS PAROLA</th>
                  <th style="width: 10%;" scope="col">UETDS DURUM</th>
                  <th scope="col">KOMUTLAR</th>
                </tr>
              </thead>
              <tbody class="tbody-margin">
                <template v-for="(vehicle, index) in vehicles">
                  <tr :key="'trow-first-' + vehicle.VehicleId">
                    <td class="align-middle text-center">{{index + 1}}</td>
                    <td class="align-middle">
                      <div class="text-truncate">
                        <p class="my-0 font-weight-bold margin-negative">{{vehicle.CustomerTitle}}</p>
                        <small class="text-muted">{{vehicle.RetailerName}}</small>
                      </div>
                    </td>
                    <td class="align-middle">
                      <div class="text-truncate">
                        <p class="my-0 font-weight-bold margin-negative">{{vehicle.VehicleName}}</p>
                        <small class="text-muted">{{vehicle.DeviceId}}</small>
                      </div>
                    </td>
                    <td class="align-middle text-center">{{vehicle.ContractName}}</td>
                    <td class="align-middle text-center">{{vehicle.WsUser}}</td>
                    <td class="align-middle text-center">{{vehicle.WsPassword}}</td>
                    <td class="align-middle text-center">{{vehicle.WsStatus}}</td>
                    <td class="align-middle">
                      <button class="btn btn-sm btn-more-radius btn-primary" data-toggle="modal"
                        data-target="#uetdsModal" @click="selectVehicle(index)">Güncelle</button>
                      <button class="btn btn-sm btn-more-radius btn-danger" data-toggle="modal" 
                        data-target="#uetdsDeleteConfirmation" @click="selectVehicle(index)">Sil</button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </v-wait>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="uetdsModal" tabindex="-1"
      role="dialog" aria-labelledby="uetdsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uetdsModalLabel">U-ETDS Entegrasyonu Ekleyin</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="integration-inserting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Entegrasyon Kaydediliyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="vehicleId">Araç Kayıt No</label>
                    <input type="text" class="form-control" v-model="newIntegration.VehicleId" id="vehicleId">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="wsUser">U-ETDS Kullanıcı Adı</label>
                    <input type="text" class="form-control" v-model="newIntegration.WsUser" id="wsUser">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="wsPassword">U-ETDS Şifre</label>
                    <input type="text" class="form-control" v-model="newIntegration.WsPassword" id="wsPassword">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="addIntegration()" class="btn btn-success">Entegrasyonu Ekle/Güncelle</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="uetdsDeleteConfirmation" tabindex="-1"
      role="dialog" aria-labelledby="uetdsDeleteConfirmationLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uetdsDeleteConfirmationLabel">U-ETDS Entegrasyonu Sil</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="integration-deleting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Entegrasyon Siliniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="alert alert-danger" role="alert">
                      Seçili araç entegrasyonunu silmek istediğinizden emin misiniz?
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="customerTitle">Müşteri</label>
                    <input type="text" disabled class="form-control" v-model="newIntegration.CustomerTitle" id="customerTitle">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="vehicleName">Araç Bilgisi</label>
                    <input type="text" disabled class="form-control" v-model="newIntegration.VehicleName" id="vehicleName">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="vehicleId">Araç Kayıt No</label>
                    <input type="text" disabled class="form-control" v-model="newIntegration.VehicleId" id="vehicleId">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="wsUser">U-ETDS Kullanıcı Adı</label>
                    <input type="text" disabled class="form-control" v-model="newIntegration.WsUser" id="wsUser">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="wsPassword">U-ETDS Şifre</label>
                    <input type="text" disabled class="form-control" v-model="newIntegration.WsPassword" id="wsPassword">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="deleteIntegration()" class="btn btn-danger">Entegrasyonu Sil</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'

export default {
  name: 'Vehicles',
  data () {
    return {
      messageText: '',
      selectedVehicleId: 0,
      selectedVehicle: {},
      newIntegration: {
        CustomerTitle: '',
        VehicleId: '',
        VehicleName: '',
        WsUser: '',
        WsPassword: ''
      },
      vehicles: [],
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      },
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
  },
  methods: {
    getVehicles() {
      this.$wait.start('vehicles-loading');

      axios
      .get('/api/uetds/vehicles')
      .then(response => {
        this.vehicles = response.data
        this.$wait.end('vehicles-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('vehicles-loading')
      })
    },
    addIntegration() {
      this.$wait.start('integration-inserting');

      axios
      .post('/api/uetds/vehicles', this.newIntegration)
      .then(response => {
        this.$wait.end('integration-inserting')
        this.getVehicles()
        this.newIntegration.VehicleId = ''
        this.newIntegration.WsUser = ''
        this.newIntegration.WsPassword = ''
        $('#uetdsModal').modal('hide')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('integration-inserting')
      })
    },
    deleteIntegration() {      
      axios
      .delete('/api/uetds/vehicles/' + this.selectedVehicleId)
      .then(response => {
        this.$wait.end('integration-deleting')
        this.getVehicles()
        this.newIntegration.VehicleId = ''
        this.newIntegration.WsUser = ''
        this.newIntegration.WsPassword = ''
        $('#uetdsDeleteConfirmation').modal('hide')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('integration-deleting')
      })
    },
    selectVehicle(index) {
      this.selectedVehicleId = this.vehicles[index].VehicleId
      this.selectedVehicle = this.vehicles[index]

      this.newIntegration.CustomerTitle = this.selectedVehicle.CustomerTitle
      this.newIntegration.VehicleId = this.selectedVehicle.VehicleId + ''
      this.newIntegration.VehicleName = this.selectedVehicle.VehicleName
      this.newIntegration.WsUser = this.selectedVehicle.WsUser
      this.newIntegration.WsPassword = this.selectedVehicle.WsPassword
    },
  },
  mounted() {
    this.getVehicles()
  }
}
</script>

<style scoped>

  div.icon-global {
    position: absolute;
    z-index: 3;
    margin-left: -36px;
    margin-top: 24px;
    width: 30px;
    height: 30px;
    padding: 4px 4px 5px 4px;
    border-radius: 15px;
  }

  div.icon-global.bg-danger {
    margin-top: -6px !important;
  }

  div.icon-global i {
    color: #FFF;
  }

  .margin-negative {
    margin-bottom: -4px !important;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table { caption-side: top !important; }
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: 0.875rem;
  }

  td a.btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .text-truncated {
    display: block !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/UetdsVehicles.vue